import React, { useEffect, useState } from 'react';
import {
    ArrowRight,
    ArrowRightBlack,
    BookCover,
    BookCoverBg,
    BookCoverBgBlack,
    DefaultBookCoverImage,
    Lock,
} from '../../assets';
import { Tooltip } from 'antd';
import store, { RootState } from '../../store';
import { useDispatch, useSelector } from 'react-redux';
import { useGetJasperMutation } from '../../api/jasper';
import { setJasperIframeOpen } from '../../features/jasperIframe/jasperIframeSlice';

interface BookCardProps {
    title: string;
    isLocked: boolean;
    cover?: string;
    book_url: string;
    className: string;
    series: string;
    book_id: any;
    onClick: (book_url: string, className: string, title: string) => void;
}
interface JasperAPiResponse {
    success: boolean;
    data: {
        url: string;
    };
}
const BookCard: React.FC<BookCardProps> = ({
    title,
    isLocked,
    cover,
    book_url,
    className,
    series,
    book_id,
    onClick,
}) => {
    let cardStyles = {};
    if (
        series?.toLocaleLowerCase() === 'ogma' ||
        series?.toLocaleLowerCase() === 'techbook'
    ) {
        cardStyles = {
            backgroundImage: `url(${isLocked ? BookCoverBgBlack : BookCoverBg})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
        };
    } else {
        cardStyles = {
            background: 'rgb(165, 204, 249, 0.2)',
            border: '1px solid rgb(82, 127, 237, 0.4)',
        };
    }

    return (
        <div
            className={`w-[11.125rem] h-[12rem] rounded-3xl shadow-lg flex flex-col items-center overflow-visible mt-[5rem] ${
                isLocked ? 'cursor-not-allowed' : 'cursor-pointer'
            }`}
            onClick={() => !isLocked && onClick(book_url, className, title)}
            style={{
                ...cardStyles,
            }}
        >
            <div
                className="w-full flex justify-center relative"
                style={{ marginTop: '-3rem' }}
            >
                <img
                    src={cover || DefaultBookCoverImage}
                    alt={title}
                    className="w-[8.8125rem] h-[11.8rem] object-cover rounded-lg"
                />
                {isLocked && (
                    <div className="absolute w-[8.8125rem] m-auto rounded-lg inset-0 bg-black bg-opacity-40 flex items-center justify-center opacity-0 hover:opacity-100 transition-opacity duration-300">
                        <span className="text-white text-sm">
                            Locked for demo
                        </span>
                    </div>
                )}
            </div>
            <div className="py-[2%] flex justify-between w-[8.8125rem] h-[3rem] px-1">
                <Tooltip title={title} placement="bottom">
                    <p
                        className={`text-[0.8125rem] font-semibold break-words w-[70%] self-center two-line-text-clamp ${
                            series?.toLocaleLowerCase() === 'ogma' ||
                            series?.toLocaleLowerCase() === 'techbook'
                                ? 'text-white'
                                : 'text-black'
                        }`}
                    >
                        {title}
                    </p>
                </Tooltip>
                {isLocked ? (
                    <img
                        className="h-[1.5rem] w-[1.5rem] self-center"
                        src={Lock}
                        alt={'Locked'}
                    />
                ) : (
                    <img
                        className="h-[1rem] w-[1.5rem] self-center"
                        src={
                            series?.toLocaleLowerCase() === 'ogma' ||
                            series?.toLocaleLowerCase() === 'techbook'
                                ? ArrowRight
                                : ArrowRightBlack
                        }
                        alt={title}
                    />
                )}
            </div>
        </div>
    );
};

export default BookCard;
